import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { MyBroadcastNotificationsResponse } from "../../model/notifications/notifications";

interface BroadcastNotificationState {
    isOnLogin: boolean;
    fetchVersion: number;
    data: MyBroadcastNotificationsResponse | null;
}

const initialState: BroadcastNotificationState = {
    isOnLogin: false,
    fetchVersion: 0,
    data: null,
};

export const broadcastNotificationSlice = createSlice({
    name: 'broadcastNotification',
    initialState,
    reducers: {
        setBroadcastOnLogin: (state, action: PayloadAction<boolean>) => {
            state.isOnLogin = action.payload;
        },
        broadcastNotificationReceived: state => {
            state.fetchVersion += 1;
        },
        setBroadcastData: (state, action: PayloadAction<MyBroadcastNotificationsResponse>) => {
            state.data = action.payload;
        },
    },
});

export const { setBroadcastOnLogin, broadcastNotificationReceived, setBroadcastData } = broadcastNotificationSlice.actions;

export default broadcastNotificationSlice.reducer;
